import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import { customersExportExcel, familyAlbumEventsGet } from 'Global/Stores/familyAlbum'

import * as selectors from './selectors'

const FamilyAlbumModule = WrappedComponent => {
  class FamilyAlbumModule extends Component {
    static propTypes = {
      events: PropTypes.array.isRequired,
      eventsDone: PropTypes.bool.isRequired,
      eventsError: PropTypes.bool.isRequired,
      eventsPending: PropTypes.bool.isRequired,
      exportToExcel: PropTypes.func.isRequired,
      getEvents: PropTypes.func.isRequired,
    }

    componentDidMount() {
      const { getEvents, eventsDone } = this.props

      if (!eventsDone) {
        getEvents()
      }
    }

    render() {
      const { events, eventsError, eventsPending } = this.props

      return <WrappedComponent events={events} hasError={eventsError} loaderPending={eventsPending && !eventsError} {...this.props} />
    }
  }

  const mapStateToProps = (state, ownProps) => ({
    events: selectors.sortedEvents(state),
    eventsDone: selectors.eventsDone(state),
    eventsError: selectors.eventsError(state),
    eventsPending: selectors.eventsPending(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    exportToExcel: customers => dispatch(customersExportExcel(customers)),
    getEvents: () => dispatch(familyAlbumEventsGet()),
  })

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(FamilyAlbumModule)
}

export default FamilyAlbumModule
